import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
} from "reactstrap";

const ContractorProfileSkeleton: React.FC = () => {
  return (
    <div className="contractor-profile-page py-4">
      <Container className="px-0">
        {/* Contractor Header Skeleton */}
        <Card className="mb-4 shadow-sm">
          <CardBody className="p-4">
            <Row className="align-items-center">
              <Col lg={3} className="text-center mb-4 mb-lg-0">
                <div 
                  className="bg-light rounded-circle mb-3 mx-auto placeholder-glow"
                  style={{ width: "120px", height: "120px" }}
                >
                  <span className="placeholder w-100 h-100 rounded-circle"></span>
                </div>
                <div className="placeholder-glow">
                  <span className="placeholder col-8"></span>
                  <div className="mt-1">
                    <span className="placeholder col-6"></span>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div className="placeholder-glow">
                  <span className="placeholder col-8 mb-3" style={{ height: '2rem' }}></span>
                  <span className="placeholder col-10 mb-3"></span>
                  <div className="mb-3">
                    <span className="placeholder col-3 me-2"></span>
                    <span className="placeholder col-3 me-2"></span>
                    <span className="placeholder col-3"></span>
                  </div>
                  <div className="contractor-details">
                    <div className="mb-2">
                      <span className="placeholder col-8"></span>
                    </div>
                    <div className="mb-2">
                      <span className="placeholder col-6"></span>
                    </div>
                    <div className="mb-2">
                      <span className="placeholder col-7"></span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={3} className="text-center text-lg-end">
                <div className="placeholder-glow">
                  <div className="bg-light p-3 rounded mb-3">
                    <span className="placeholder col-12"></span>
                    <span className="placeholder col-8"></span>
                  </div>
                  <div className="bg-light p-3 rounded mb-2 w-100" style={{ height: '48px' }}></div>
                  <div className="bg-light p-3 rounded w-100" style={{ height: '48px' }}></div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* Overview Section Skeleton */}
        <Card className="mb-4 shadow-sm">
          <CardHeader>
            <div className="placeholder-glow">
              <span className="placeholder col-4" style={{ height: '1.5rem' }}></span>
            </div>
          </CardHeader>
          <CardBody className="p-4">
            <Row>
              <Col lg={8}>
                <div className="placeholder-glow">
                  <span className="placeholder col-12 mb-3"></span>
                  <span className="placeholder col-11 mb-3"></span>
                  <span className="placeholder col-10 mb-3"></span>
                  <span className="placeholder col-9 mb-4"></span>
                  
                  <span className="placeholder col-5 mb-3" style={{ height: '1.5rem' }}></span>
                  <Row className="g-3 mb-5">
                    {[1,2,3].map(i => (
                      <Col md={4} key={i}>
                        <div className="p-3 bg-light rounded">
                          <span className="placeholder col-8 mb-2"></span>
                          <span className="placeholder col-6"></span>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Col>
              <Col lg={4}>
                <Card className="border-0 bg-light mb-4">
                  <CardHeader className="bg-secondary">
                    <span className="placeholder col-6 bg-light"></span>
                  </CardHeader>
                  <CardBody className="p-4">
                    <div className="placeholder-glow">
                      {[1,2,3,4].map(i => (
                        <div key={i} className="d-flex mb-4">
                          <div className="bg-light rounded me-3" style={{ width: '24px', height: '24px' }}></div>
                          <div className="flex-grow-1">
                            <span className="placeholder col-8 mb-1"></span>
                            <span className="placeholder col-6"></span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* Services Section Skeleton */}
        <Card className="mb-4 shadow-sm">
          <CardHeader>
            <div className="placeholder-glow">
              <span className="placeholder col-3" style={{ height: '1.5rem' }}></span>
            </div>
          </CardHeader>
          <CardBody className="p-4">
            <Row>
              {[1,2,3,4,5,6].map(i => (
                <Col lg={4} md={6} key={i} className="mb-3">
                  <div className="p-4 bg-light rounded d-flex align-items-center">
                    <div className="bg-white rounded me-3" style={{ width: '48px', height: '48px' }}></div>
                    <span className="placeholder col-8"></span>
                  </div>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>

        {/* Gallery Section Skeleton */}
        <Card className="mb-4 shadow-sm">
          <CardHeader>
            <div className="placeholder-glow">
              <span className="placeholder col-4" style={{ height: '1.5rem' }}></span>
            </div>
          </CardHeader>
          <CardBody className="p-4">
            <Row className="g-4">
              {[1,2,3,4,5,6].map(i => (
                <Col lg={4} md={6} key={i}>
                  <Card className="border-0 shadow-sm">
                    <div className="bg-light" style={{ height: '200px' }}></div>
                    <CardBody>
                      <span className="placeholder col-8"></span>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>

        {/* Reviews Section Skeleton */}
        <Card className="mb-4 shadow-sm">
          <CardHeader>
            <div className="d-flex justify-content-between align-items-center">
              <span className="placeholder col-3" style={{ height: '1.5rem' }}></span>
              <div className="bg-light rounded" style={{ width: '120px', height: '40px' }}></div>
            </div>
          </CardHeader>
          <CardBody className="p-4">
            <Row className="g-4">
              <Col lg={8}>
                {[1,2,3].map(i => (
                  <Card key={i} className="mb-4 border-0 shadow-sm">
                    <CardBody className="p-4">
                      <div className="placeholder-glow">
                        <div className="d-flex justify-content-between mb-3">
                          <div>
                            <span className="placeholder col-6 mb-1"></span>
                            <span className="placeholder col-4"></span>
                          </div>
                          <span className="placeholder col-3"></span>
                        </div>
                        <div className="mb-3">
                          <span className="placeholder col-4"></span>
                        </div>
                        <span className="placeholder col-12 mb-2"></span>
                        <span className="placeholder col-11 mb-2"></span>
                        <span className="placeholder col-9"></span>
                      </div>
                    </CardBody>
                  </Card>
                ))}
              </Col>
              <Col lg={4}>
                <Card className="border-0 shadow-sm">
                  <CardHeader className="bg-secondary">
                    <span className="placeholder col-5 bg-light"></span>
                  </CardHeader>
                  <CardBody className="p-4">
                    <div className="text-center mb-4 placeholder-glow">
                      <span className="placeholder col-4 mb-2" style={{ height: '3rem' }}></span>
                      <span className="placeholder col-8 mb-2"></span>
                      <span className="placeholder col-6"></span>
                    </div>
                    <div className="placeholder-glow">
                      {[5,4,3,2,1].map(star => (
                        <div key={star} className="d-flex align-items-center mb-2">
                          <span className="placeholder col-3 me-2"></span>
                          <div className="flex-grow-1 bg-light rounded" style={{ height: '8px' }}></div>
                          <span className="placeholder col-2 ms-2"></span>
                        </div>
                      ))}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* Credentials Section Skeleton */}
        <Card className="mb-4 shadow-sm">
          <CardHeader>
            <div className="placeholder-glow">
              <span className="placeholder col-5" style={{ height: '1.5rem' }}></span>
            </div>
          </CardHeader>
          <CardBody className="p-4">
            <Row className="g-4">
              <Col lg={6}>
                <Card className="border-0 shadow-sm">
                  <CardHeader className="bg-white">
                    <span className="placeholder col-6"></span>
                  </CardHeader>
                  <CardBody className="p-4">
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            {[1,2,3,4].map(i => (
                              <th key={i}>
                                <span className="placeholder col-8"></span>
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {[1,2].map(i => (
                            <tr key={i}>
                              {[1,2,3,4].map(j => (
                                <td key={j}>
                                  <span className="placeholder col-10"></span>
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={6}>
                <Card className="border-0 shadow-sm">
                  <CardHeader className="bg-white">
                    <span className="placeholder col-5"></span>
                  </CardHeader>
                  <CardBody className="p-4">
                    <div className="placeholder-glow">
                      <div className="mb-4">
                        <span className="placeholder col-3 me-2"></span>
                        <span className="placeholder col-4"></span>
                      </div>
                      <table className="table table-bordered">
                        <tbody>
                          {[1,2,3].map(i => (
                            <tr key={i}>
                              <th className="bg-light">
                                <span className="placeholder col-6"></span>
                              </th>
                              <td>
                                <span className="placeholder col-8"></span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* Call-to-Action Skeleton */}
        <Card className="mt-4 mb-0 bg-light border-0 shadow-sm">
          <CardBody className="p-5">
            <Row className="align-items-center">
              <Col lg={8}>
                <div className="placeholder-glow">
                  <span className="placeholder col-8 mb-2" style={{ height: '2rem' }}></span>
                  <span className="placeholder col-10"></span>
                </div>
              </Col>
              <Col lg={4} className="text-lg-end">
                <div className="d-flex flex-column flex-lg-row gap-2">
                  <div className="bg-primary rounded" style={{ height: '48px', flex: 1 }}></div>
                  <div className="bg-success rounded" style={{ height: '48px', flex: 1 }}></div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default ContractorProfileSkeleton;